import { TabCard, TabProps } from 'components';
import { FileProtectOutlined, ProfileOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Worker } from 'app/types/worker';
import Data from './Data';
import DocumentsTable from './document/Table';
import NewDocument from './document/CreateButton';

type TabsProps = {
  worker: Worker;
};

const Tabs = ({ worker }: TabsProps) => {
  const { t } = useTranslation();

  const tabs: TabProps[] = [
    {
      key: 'data',
      title: t('tabs.details'),
      icon: <ProfileOutlined />,
      content: <Data worker={worker} />,
    },
    {
      key: 'documents',
      title: t('tabs.documents'),
      icon: <FileProtectOutlined />,
      content: <DocumentsTable worker={worker} />,
      actions: <NewDocument worker={worker} />,
    },
  ];

  return <TabCard tabs={tabs} />;
};

export default Tabs;
